import React from 'react';
import NumberFormat from 'react-number-format';
import Textfield from 'components/textfield';

const MoneyInput = ({ onChange, onBlur, value, ...rest }: any) => {
  let parsedValue = value;
  if(typeof parsedValue === 'number') {
    parsedValue = Number(parsedValue).toFixed(2)
    // onChange(parsedValue);
  }
  // eslint-disable-next-line react/destructuring-assignment
  return (
    <NumberFormat
      onValueChange={(values) => {
        // onChange(Number(values.value).toFixed(2));
        onChange(values.value);
      }}
      onBlur={(e) => {
        onChange(Number(value).toFixed(2));
        onBlur(e);
      }}
      isNumericString
      // onChange={(e) => console.log('onchange', e.target.value)}
      fixedDecimalScale={false}
      decimalSeparator=","
      thousandSeparator="."
      prefix=""
      decimalScale={2}
      customInput={Textfield}
      value={parsedValue}
      {...rest}
    />)
};
export default React.memo(MoneyInput);
// export default MoneyInput;
